document.addEventListener('DOMContentLoaded', function() {
  // Listen for Recharge subscription selection changes
  if (window.RechargeEvents) {
    window.RechargeEvents.addEventListener('subscription-selected', function(event) {
      const quantity = event.detail.quantity || 1;
      const stickyCartInput = document.querySelector('[data-sticky-cart-quantity]');
      if (stickyCartInput) {
        stickyCartInput.value = quantity;
      }
    });
  }
  
  // Also sync when the form is submitted
  const addToCartForm = document.querySelector('form[action*="/cart/add"]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function() {
      const rechargeQuantity = document.querySelector('[data-recharge-quantity]')?.value || 1;
      const quantityInput = this.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = rechargeQuantity;
      }
    });
  }
});
